"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonInputStyles = exports.Wrapper = exports.Label = exports.Input = exports.Error = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _common = require("../../styles/common");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
    display: inline-flex;
    flex-direction: column;
    position: relative;
    max-width: 100%;
`;
exports.Wrapper = Wrapper;
const Label = _styledComponents.default.label`
    ${_common.textSecondary};
    line-height: 16px;
    min-height: 16px;
`;
exports.Label = Label;
const Error = _styledComponents.default.div`
    ${_common.textSecondary};
    color: var(--vcs-color--error);
    margin-top: 2px;
    line-height: 16px;
    min-height: 16px;  // Keep the space reserved si when error appears, it doesn't jump
`;
exports.Error = Error;
const focusStyles = (0, _styledComponents.css)`
    outline: none;
    box-shadow: none;
    border-color: var(--text-primary-color);
`;
const commonInputStyles = (0, _styledComponents.css)`
    color: var(--text-primary-color);
    background-color: var(--input-bg-color);
    font-size: 14px;

    transition: border-color 0.2s ease-in;
    border: 1px solid var(--input-border-color);
    border-radius: 2px;

    ${({
  disabled
}) => disabled && _common.disabled}
    ${({
  focused
}) => focused && focusStyles}
    
    &.focus,
    &:focus,
    &:focus-visible {
        ${focusStyles}
    }
`;
exports.commonInputStyles = commonInputStyles;
const Input = _styledComponents.default.input`
    padding: 7px;
    ${commonInputStyles};

    // Focus should have higher priority than error outline.
    ${({
  errorText
}) => errorText && (0, _styledComponents.css)`outline: 2px solid rgba(var(--vcs-color--error-rgb), 0.5);`}
`;
exports.Input = Input;